import Vue from 'vue';
import Tools from '../../providers/tools';


export const ContentTextFilter = Vue.filter('contentText', (value) => {
  return Tools.htmlDecode(value);
});